export function getCookie(name) {
  const cookie = document.cookie.split(';').map((pairStr) => pairStr.trim());
  const matches = cookie.find((pair) => pair.startsWith(`${name}=`));
  if (matches) {
    const cookieValue = matches.substring(name.length + 1);
    return decodeURIComponent(cookieValue);
  }
  return undefined;
}

export function setCookie(name, value, options = {}) {
  const cookieOptions = { ...options };
  let { expires } = cookieOptions;

  if (typeof expires === 'number' && expires) {
    const d = new Date();
    d.setTime(d.getTime() + expires * 1000);
    expires = d;
    cookieOptions.expires = d;
  }
  if (expires && expires.toUTCString) {
    cookieOptions.expires = expires.toUTCString();
  }

  // For dev mode with proxy, add SameSite=None and Secure for cross-origin cookies
  if (process.env.NODE_ENV === 'development' && process.env.PROXY === 'true') {
    // Only add Secure if using HTTPS (but we're on HTTP, so skip Secure)
    // SameSite=None requires Secure, but we can't use Secure on HTTP
    // So we'll use SameSite=Lax for localhost
    if (!cookieOptions.sameSite) {
      cookieOptions.sameSite = 'Lax';
    }
  }

  const encodedValue = encodeURIComponent(value);
  let updatedCookie = `${name}=${encodedValue}`;

  Object.keys(cookieOptions).forEach((propName) => {
    updatedCookie += `; ${propName}`;
    const propValue = cookieOptions[propName];
    if (propValue !== true) {
      updatedCookie += `=${propValue}`;
    }
  });

  document.cookie = updatedCookie;

  // Debug: verify cookie was set
  if (process.env.NODE_ENV === 'development') {
    const verifyCookie = getCookie(name);
    if (!verifyCookie || verifyCookie !== value) {
      // eslint-disable-next-line no-console
      console.warn('[Auth Debug] Cookie may not have been set correctly', {
        name,
        expected: `${value.substring(0, 20)}...`,
        actual: verifyCookie
          ? `${verifyCookie.substring(0, 20)}...`
          : 'missing',
        cookieString: document.cookie,
        cookieOptions,
      });
    }
  }
}

export function deleteCookie(name) {
  setCookie(name, '', {
    expires: -1,
  });
}
